import { useState, useEffect } from "react";
import { Row, Col, BackTop, Empty, Skeleton, Modal, Button } from "antd";
import { LoginOutlined } from "@ant-design/icons";
import StepsGeneral from "../components/StepsLogsGeneral";
import MainLayout from "../layouts/Main";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import OrderUsers from "../components/Generals/OrderUsers/OrderUsers";
import OrderService from '../utils/api/orders';
import NewOrderInfo from "../components/OrderInfo/NewOrderInfo";
import ChatService from "../utils/api/chat";

export default function NewOrderDetails() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const role = Number(localStorage.getItem("role"));


  const [categories, setCategories] = useState([]);
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);

  const [order, setOrder] = useState([]);

  const [service, setService] = useState({});
  const [orderLogs, setOrderLogs] = useState([])

  const [reload, setReload] = useState(false);

  const [chats, setChats] = useState([]);

  const [isAccessBlocked, setIsAccessBlocked] = useState(false);
  const [isLoginGateModalOpen, setIsLoginGateModalOpen] = useState(false);

  let token = localStorage.getItem("token");

  useEffect(() => {
    let parsedUser = null;
    try {
      parsedUser = JSON.parse(localStorage.getItem("user") || "null");
    } catch (error) {
      parsedUser = null;
    }

    const hasSession = Boolean(
      localStorage.getItem("token") || (parsedUser?.id && localStorage.getItem("role"))
    );

    if (hasSession) {
      setIsAccessBlocked(false);
      setIsLoginGateModalOpen(false);
      return;
    }

    const currentPagePath = `${location.pathname}${location.search || ""}${location.hash || ""}`;
    localStorage.setItem("post_login_redirect", currentPagePath);
    setIsAccessBlocked(true);
    setIsLoginGateModalOpen(true);
    setLoading(false);
  }, [location.pathname, location.search, location.hash]);

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  const handleRegisterRedirect = () => {
    navigate("/register");
  };

  useEffect(() => {
    if (isAccessBlocked) {
      return;
    }

    let isCurrentRequest = true;

    // Reset local state when URL id changes to avoid showing stale order data.
    setLoading(true);
    setOrder([]);
    setOrderLogs([]);
    setChats([]);

    const fetchData = async () => {
      try {
        // 1. Obtener la orden
        const resp = await OrderService.GetOrderById(id);
        let orderData = resp.data.order;

        // 2. Si el usuario es tipo 6, filtrar services con status >= 2
        if (role === 6 && Array.isArray(orderData.services)) {
          orderData.services = orderData.services.filter(
            service => service.status >= 2
          );
        }

        // 3. Guardar la orden filtrada en el estado
        if (!isCurrentRequest) return;
        setOrder(orderData);

        // 4. Cargar chats filtrados
        const user = JSON.parse(localStorage.getItem("user"));
        const category = user.cat || user.role_data?.cat1 || user.vs || null;
        const chatResp = await ChatService.GetByUser(user.id, {
          role: user.role,
          category,
          orderId: id,
        }); 
        if (isCurrentRequest && chatResp.data?.success) {
          setChats(chatResp.data.chats || []);
        }

      } catch (error) {
        console.error("Error fetching order or chats:", error);
        if (isCurrentRequest) {
          setOrder("");
        }
      } finally {
        if (isCurrentRequest) {
          setLoading(false);
        }
      }
    };

    fetchData();

    // Cargar logs de la orden
    OrderService.OrderLogs(id)
      .then(resp => {
        if (isCurrentRequest) {
          setOrderLogs(resp.data.logs || []);
        }
      })
      .catch(console.error);

    return () => {
      isCurrentRequest = false;
    };

  }, [id, role, isAccessBlocked]);


    return (
      <MainLayout>
        <Modal
          open={isLoginGateModalOpen}
          onCancel={() => {}}
          footer={null}
          centered
          closable={false}
          maskClosable={false}
          keyboard={false}
          width={420}
          bodyStyle={{ padding: 0 }}
        >
          <div
            style={{
              background: "#0F5197",
              color: "#fff",
              padding: "28px 24px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 0.15)",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 12,
              }}
            >
              <LoginOutlined style={{ fontSize: 28, color: "#fff" }} />
            </div>
            <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>
              Inicia sesión para continuar
            </h2>
            <p style={{ margin: "8px 0 0", fontSize: 14, opacity: 0.95 }}>
              Para ver el detalle de esta orden, primero debes autenticarte.
            </p>
          </div>
          <div style={{ padding: "18px 24px 24px" }}>
            <Button
              type="primary"
              block
              size="large"
              onClick={handleLoginRedirect}
              style={{
                background: "#0F5197",
                borderColor: "#0F5197",
                fontWeight: 600,
              }}
            >
              Iniciar sesión
            </Button>
            <Button
              block
              size="large"
              onClick={handleRegisterRedirect}
              style={{ marginTop: 12, fontWeight: 600 }}
            >
              Crear cuenta
            </Button>
          </div>
        </Modal>

        {isAccessBlocked ? null : loading === true ? (
          <>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </>
        ) : order === "" ? (
          <Empty description="No hay informacion sobre esta orden." />
        ) : (
          <Row gutter={[12, 12]}>
            <Col xs={24} sm={24} md={24} lg={16} xl={16} >
              <NewOrderInfo
                serviceData = {order}
                client = {order.client}
                reload={reload}
                role={role}
                token={token}
                setReload={setReload}
                categorias={categories}
                unidades={units}
              />
            </Col>
            {/* TODO: ADD THIS FUNCTIONS*/}
            {
            <Col xs={24} lg={8} xl={8}>
              <Row gutter={[12, 12]}>
                {
                <Col xs={24}>
                  <OrderUsers chats={chats} service={service} token={token} op={1} />
                </Col>
                }
                <Col xs={24}>
                  <StepsGeneral steps={orderLogs} order={order}/>
                </Col>

                {/* 
                <Col xs={24}>
                  {role === 4 &&
                    order.service.step_id >= 7 &&
                    order.service.step_id < 11 && (
                      <Rate
                        rate={order.rate}
                        order={order.service}
                        id={order.service.id}
                        reload={reload}
                        setReload={setReload}
                        step={order.service.step_id}
                        title="Calificar orden"
                      />
                    )}
                </Col>
                */}
              </Row>
            </Col>
            }
          </Row>
        )}
        <BackTop />
      </MainLayout>
    );
}

